import { invalidateAallNotificationQueries } from "@/modules/inbox/queries";
import { toast } from "sonner";
import {
  updateNotificationStatus,
  updateNotificationsStatus,
} from "directus/src/operations";
import { useMutation } from "@tanstack/react-query";

export function useMarkReadMutation(options = {}) {
  return useMutation({
    mutationFn: ({ id, status = "archived" }) =>
      updateNotificationStatus(id, status),
    onSuccess: (_, variables) => {
      toast(
        variables.status === "inbox"
          ? "Notification moved to pending"
          : "Notification marked as read"
      );
      invalidateAallNotificationQueries();
      options.onSuccess?.();
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
}

export function useBulkMarkStatusMutation(options = {}) {
  return useMutation({
    mutationFn: async ({ ids, status = "archived" }) => {
      if (!ids || ids.length === 0) return;
      return await updateNotificationsStatus(ids, status);
    },
    onSuccess: (_, variables) => {
      const count = variables.ids?.length || 0;
      const isArchived = variables.status === "archived";
      toast.success(
        `${count} notification${count > 1 ? "s" : ""} ${
          isArchived ? "cleared" : "moved to pending"
        }`
      );
      invalidateAallNotificationQueries();
      options.onSuccess?.();
    },
    onError: (error) => {
      toast.error(error.message || "Failed to update notifications");
      console.error(error);
    },
  });
}
